import React from 'react';

export const useInvestorContactEditingState = () => {
  const [isEditing, setIsEditing] = React.useState(false);

  return {
    isEditingInvestorContacts: isEditing,
    setIsEditingInvestorContacts: setIsEditing,
  };
};
